import React, { forwardRef } from 'react';
import cm from 'classnames';
import styles from './_track-container.module.scss';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  clipId?: CellClip;
}

const Track = ({ className, children, ...rest }: Props) => {
  return (
    <div {...rest} className={cm(styles.Track, className)}>
      {children}
    </div>
  );
};

const TrackHeader = forwardRef<HTMLDivElement, Props>(({ className, children, ...rest }, ref) => {
  return (
    <div {...rest} ref={ref} className={cm(styles.Track__header, className)}>
      {children}
    </div>
  );
});

const TrackBody = forwardRef<HTMLDivElement, Props>(({ className, children, ...rest }: Props, ref) => {
  return (
    <div {...rest} ref={ref} className={cm(styles.Track__body, className)}>
      {children}
    </div>
  );
});

const TrackFeed = forwardRef<HTMLDivElement, Props>(({ className, children, ...rest }: Props, ref) => {
  return (
    <div {...rest} ref={ref} className={cm(styles.Track__feed, className)}>
      {children}
    </div>
  );
});

const TrackCell = ({ width, className, children, clipId, ...rest }: { width: number } & Props) => {
  const transitionStyle = { transition: clipId ? 'flex-basis 0.5s ease-in, max-width 0.3s ease-in' : '' };

  return (
    <div
      {...rest}
      style={{ flex: `0 0 ${width}%`, maxWidth: `${width}%`, ...transitionStyle }}
      className={cm(styles.Track__cell, className)}
    >
      {children}
    </div>
  );
};

TrackHeader.displayName = 'TrackHeader';
TrackBody.displayName = 'TrackBody';
TrackFeed.displayName = 'TrackFeed';

export { Track, TrackHeader, TrackBody, TrackFeed, TrackCell };
